export default {
  ANONYMOUS: { id: 55, name: "Anonymous" },
  ANONYMOUS_UNIVERSE: { id: 56, name: "Universe Anonymous" },
  FAMILY: { id: 54, name: "Family" },
  UNREGISTERED_FAMILY: { id: 58, name: "Unregistered Family" },
  UNREGISTERED_TEACHER: { id: 57, name: "Unregistered Teacher" },
  CLASSROOM_TEACHER: { id: 10, name: "Classroom Teacher" },
};
